var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFE"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.343 22.84l-2.336-1.34-3.108 1.783 1.556.892-21.697 12.45-15.98-9.17 1.718-.985-3.108-1.784L.89 26.12c-.48.275-.777.787-.777 1.335 0 .55.298 1.06.777 1.336l19.088 10.953c.474.272 1.088.272 1.562 0L46.343 25.51c.48-.275.777-.786.777-1.335 0-.548-.297-1.06-.777-1.335M37.423 13.705L26.781 7.6c-.213-.122-.453-.184-.693-.184-.24 0-.48.062-.693.184L9.31 16.828l11.335 6.504 16.777-9.627",
    transform: "translate(-36 -12) translate(36 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.036 17.5l-.695-.399-21.218 12.175c-.456.262-.966.392-1.477.392-.511 0-1.022-.13-1.477-.392L3.393 20.224l-.42.241c-.426.244-.69.699-.69 1.185 0 .487.264.941.69 1.185l17.254 9.9c.42.243.966.242 1.387 0L44.036 19.87c.425-.244.69-.698.69-1.185 0-.487-.265-.941-.69-1.185",
    transform: "translate(-36 -12) translate(36 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.666 15.775l21.696-12.45 15.98 9.17-21.696 12.45-15.98-9.17zm41.566-1.945c.479-.275.776-.786.776-1.335 0-.548-.297-1.06-.776-1.335L27.143.207c-.24-.138-.51-.207-.78-.207s-.54.069-.781.207L.777 14.44c-.48.275-.777.787-.777 1.335 0 .548.298 1.06.777 1.335l19.088 10.953c.474.273 1.088.272 1.562 0L46.232 13.83z",
    transform: "translate(-36 -12) translate(36 12)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5a81636110fab2f79fe159aabc3865e8.svg";
export { ForwardRef as ReactComponent };